<div class="uploader">
  <uppy-dashboard [uppy]="uppy" [props]="uppyDashboardOptions"></uppy-dashboard>
  <div class="actions">
    <button mat-button (click)="cancel()">CANCEL</button>
    <button mat-flat-button color="primary" [disabled]="!hasFiles" (click)="Ok()">OK</button>
  </div>
</div>